import * as nvps from './nvps.js';

export default {
    nvps,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Admin
    window.EQLAPP.NVPS = window.EQLAPP.NVPS || {};
    Object.entries(nvps).forEach(([key, value]) => {
        window.EQLAPP.NVPS[key] = value;
    });

}